export default {"src":"/_next/static/media/hero-background.40eb241c.svg","height":462,"width":860,"blurWidth":0,"blurHeight":0};